export default __webpack_public_path__ + "static/media/004-B-sport.827127ff.svg";